import { Component, OnInit } from '@angular/core';
import { ModalController } from '@ionic/angular';
import { Input } from '@angular/core';

@Component({
  selector: 'app-driver-timeout',
  templateUrl: './driver-timeout.component.html',
  styleUrls: ['./driver-timeout.component.scss']
})
export class DriverTimeoutComponent implements OnInit {
  @Input('data') data:any;

  constructor(    private modalController: ModalController,
    ) { }

  ngOnInit(): void {
  }

  dismiss() {
    // using the injected ModalController this page
    // can "dismiss" itself and optionally pass back data
    this.modalController.dismiss({
      dismissed: true,
    });
  }

  refresh(){
    window?.location?.reload();
  }
}
